<template>
  <div class="staff-con">
    <div v-if="loading" style="text-align: center; padding-top: 100px">
      <loading size="24px">员工列表加载中...</loading>
    </div>
    <template v-else-if="!loading && this.staffList.length>0">
      <div class="header">
        <div class="title">请选择员工</div>
        <div class="tips">
          <p>1、11:00前订最快明天配送, 11:00后订最快2天后配送</p>
          <p>2、配送日前一天11:00前可取消订单</p>
        </div>
      </div>
      <div class="list">
        <div class="staff" v-for="staff in staffList" :key="staff.id">
          <checkbox
            v-model="staff.checked"
            class="_checkbox"
            checked-color="#ef4c4f"
            :disabled="!staff.checked && celebrateList.length>=1"
          >
            <div class="con">
              <div class="icon">
                <img src="https://web-data.zmlearn.com/image/g1NTMGxiRBnqwiXp4XPsWr/birthday.png" />
              </div>
              <div class="desc">
                <div class="name">{{staff.personName}}</div>
                <div class="date">生日：{{staff.birthday}}</div>
                <div class="expes">过期时间：{{staff.validityDay}}</div>
              </div>
            </div>
          </checkbox>
        </div>
      </div>
    </template>
    <div v-else class="space-con">
      <empty description="最近没有员工过生日哦" />
    </div>
  </div>
</template>

<script>
import { Checkbox, Loading, Empty } from 'vant';
import { queryOrderDetailsInfos } from '@/api/birthday';

export default {

  components: {
    Checkbox,
    Loading,
    Empty,
  },

  data() {
    return {
      loading: false,
      staffList: [],
    };
  },

  mounted() {
    this.init();
  },

  computed: {
    celebrateList() {
      return this.staffList.filter(_s => _s.checked);
    },
  },

  methods: {
    init() {
      this.loading = true;
      queryOrderDetailsInfos().then(res => {
        res = res.map(_staff => {
          _staff.checked = false;
          return _staff;
        });
        this.staffList = res;
      }).catch(({ message = '系统异常' }) => {
        this.$toast(message);
      }).finally(() => {
        this.loading = false;
      });
    },

    /**
     * 下一步检查
     */
    nextCheck() {
      return this.celebrateList.length > 0 ? this.celebrateList : null;
    },
  },
};
</script>

<style lang="scss" scoped>
div {
  box-sizing: border-box;
}

.list {
  .staff {
    margin-bottom: 20px;
    .con {
      width: 100%;
      padding: 20px;
      border-radius: 20px;
      background-color: #fff;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .icon {
        & > img {
          width: 80px;
        }
      }
      .desc {
        margin-left: 10px;
        .name {
          font-weight: bold;
          font-size: 28px;
        }
        .date {
          font-size: 26px;
        }
        .expes {
          margin-top: 10px;
          font-size: 22px;
          color: #ff7820;
        }
      }
    }
  }
}
.space-con {
  text-align: center;
}
</style>

<style lang="scss">
.staff-con .staff .van-checkbox__label {
  display: inline-block;
  width: 100%;
}
</style>